<template>
  <section>
    <cursoHeader></cursoHeader>
    <div class="bg-white border border-gray my2 p2">
      <div>
        <apresentacaoDoExercicio></apresentacaoDoExercicio>
        <div v-show="$dados.RODADAS.length == 0">
          <span
            class="btn btn-primary"
            @click="iniciar()"
          >
            Iniciar
          </span>
        </div>
        <resumoDeRodadas></resumoDeRodadas>
        <hr class="mt3" />
        <div>
          <span
            class="btn"
            @click="voltar()"
          >
            <i class="material-icons">arrow_back</i> voltar
          </span>
        </div>
      </div>
    </div>
    <menuBotoes></menuBotoes>
  </section>
</template>

<script>
import apresentacaoDoExercicio from '@/custom/apresentacaoDoExercicio'
import cursoHeader from '@/custom/cursoHeader'
import menuBotoes from '@/custom/menuBotoes'
import resumoDeRodadas from '@/custom/resumoDeRodadas'
var componentData = {
}
var componentDefinition = {
  components: { apresentacaoDoExercicio, cursoHeader, menuBotoes, resumoDeRodadas },
  created: function () {
  },
  mounted: function () {
  },
  data: function () {
    return componentData
  },
  methods: {
    iniciar: function () {
      this.$requests.post([
        '/SATACS/ALUNO',
        this.$auth.user.id,
        'MATRICULA',
        this.$route.params.idmatricula,
        this.$route.name,
        'RODADA',
        'BLOCO',
        this.$route.params.idbloco
      ].join('/')).then(response => {
        this.refresh()
      })
    },
    refresh: function (rodada, operacao) {
      var params = this.$route.params
      params.refresh = (params.refresh || 0) * 1
      ++params.refresh
      this.$router.replace({
        name: this.$route.name,
        params: params
      })
    },
    voltar: function () {
      var params = this.$route.params
      var route = {
        name: 'ASSUNTOS',
        params: {
          idaluno: params.idaluno,
          idmatricula: params.idmatricula,
          idbloco: params.idbloco
        }
      }
      this.$router.push(route)
    }
  }
}
export default componentDefinition
</script>
